//import {useListView} from '../../core/ListViewProvider'
//import {LicensesListGrouping} from './LicensesListGrouping'
import {LicensesListFilter} from './LicensesListFilter'

interface props {
  data?: any
  onDataFromChild: (data: any) => void
}

// const LicensesListHeader = (data: any, onDataFromChild: any) => {
const LicensesListHeader: React.FC<props> = ({data, onDataFromChild}) => {
  const handleDataFromChild = (data2: any): void => {
    onDataFromChild(data2)
  }
  return (
    <>
      <LicensesListFilter data={data} onDataFromChild={handleDataFromChild} />
    </>
  )
}

export {LicensesListHeader}
